import { gql } from '@apollo/client';

export const CREATE_TRANSPORTATION = gql`
  mutation createTransportation($name: String!, $type: String!, $seats: Int!, $color: String!) {
    createTransportation(name: $name, type: $type, seats: $seats, color: $color) {
      id
      name
      type
      seats
      color
    }
  }
`;

export const UPDATE_TRANSPORTATION = gql`
  mutation updateTransportation($id: Int!, $name: String, $type: String, $seats: Int, $color: String) {
    updateTransportation(id: $id, name: $name, type: $type, seats: $seats, color: $color) {
      id
      name
      type
      seats
      color
    }
  }
`;

export const DELETE_TRANSPORTATION = gql`
  mutation deleteTransportation($id: Int!) {
    deleteTransportation(id: $id) {
      id
    }
  }
`;
